import { getMessage } from '@tcc/i18n';
import { RootLevelDimensions } from '../../../../types/FieldRegionReport';
import { RegionReportStats } from '../RegionReportStats/RegionReportStats';
import { useAppSelector } from '../../../../utils/useAppSelector';
import { getCurrentSeasonHybridsColor } from '../../../../selectors';
import { SetItemCallback } from '../container/useRegionReportController';

export interface ArdRegionReportListProps {
  data: RootLevelDimensions;
  areaUnit: string;
  cropCode: string;
  index: number;
  listView?: boolean;
  onClickItem?: SetItemCallback;
}

export const ArdRegionReportList = ({
  data,
  areaUnit,
  cropCode,
  index,
  listView,
  onClickItem,
}: ArdRegionReportListProps) => {
  const colors = useAppSelector((state) => getCurrentSeasonHybridsColor(state, { index }));

  return (
    <>
      {'bySeedProduct' in data.dimensions && data.dimensions.bySeedProduct.length > 0 && (
        <RegionReportStats
          areaUnit={areaUnit}
          colors={colors}
          cropCode={cropCode}
          data={data.dimensions.bySeedProduct}
          dataTestId="hybrids"
          headerText={getMessage('regions.report.modal.byHybrid')}
          index={index}
          onClickItem={listView ? onClickItem : undefined}
          showIcon
          isArdData
        />
      )}
      {'byPopulation' in data.dimensions && data.dimensions.byPopulation.length > 0 && (
        <RegionReportStats
          allowHover
          areaUnit={areaUnit}
          cropCode={cropCode}
          data={data.dimensions.byPopulation}
          dataTestId="population"
          headerText={getMessage('regions.report.modal.byPopulation')}
          index={index}
          onClickItem={listView ? onClickItem : undefined}
          showIcon
          displayRanges
          isArdData
        />
      )}

      {'byElevation' in data.dimensions && data.dimensions.byElevation.length > 0 && (
        <RegionReportStats
          allowHover
          areaUnit={areaUnit}
          cropCode={cropCode}
          data={data.dimensions.byElevation}
          dataTestId="elevation"
          headerText={getMessage('regions.report.modal.byElevation')}
          index={index}
          onClickItem={listView ? onClickItem : undefined}
          showIcon
          displayRanges
          isArdData
        />
      )}

      {'byPlantingDate' in data.dimensions && data.dimensions.byPlantingDate.length > 0 && (
        <RegionReportStats
          allowHover
          areaUnit={areaUnit}
          cropCode={cropCode}
          data={data.dimensions.byPlantingDate}
          dataTestId="planterDate"
          headerText={getMessage('regions.report.modal.byPlanterDate')}
          index={index}
          onClickItem={listView ? onClickItem : undefined}
          showIcon
          displayRanges
          isArdData
        />
      )}
    </>
  );
};
